import { useMemo } from 'react';
import { nth } from 'lodash';
import { useGetList } from 'react-admin';
import useGetTokenFromLocalStorage from '@/hooks/use-get-token-from-local-storage';
import extractIdFromURI from '@/utils/id';
import { composeMediaFmDownloadUrl } from '@/utils/compose';

interface Props {
    resource: string;
    resourceId: string | undefined;
    tagsName?: string[];
}

const useGetFile = ({ tagsName = [], resourceId, resource }: Props) => {
    const getTokenFromLocalStorage: any = useGetTokenFromLocalStorage();

    const { data, isLoading, refetch } = useGetList(
        'smartConnectView/file_system_mappers',
        {
            filter: {
                'parent.parent.name': `sc:folder-${resource}:${resourceId}`,
                lvl: 5,
                ...(tagsName.length > 0 && { 'tags.name': tagsName }),
            },
            sort: {
                field: 'createdAt',
                order: 'DESC',
            },
            meta: {
                basePath: 'fm',
            },
        },
        { enabled: resourceId !== undefined },
    );

    const file: any = useMemo(() => {
        const firstFile = nth(data, 0);

        if (!firstFile) {
            return undefined;
        }

        const name = firstFile.name;
        const fmId = extractIdFromURI(firstFile['@id']) as string;
        const mediaId = firstFile.metadata['metadata.extra']['coreapi.mediaid'];

        return {
            name,
            fmId,
            mediaId,
            url: composeMediaFmDownloadUrl(mediaId, getTokenFromLocalStorage()),
        };
    }, [data, getTokenFromLocalStorage]);

    return {
        file,
        isLoading,
        refetch,
    };
};

export default useGetFile;
